import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import {
  PageTitle,
  PageTitleByBreadcrumbAlias,
  PageTitleByRoutePath,
} from '../utility/constants';

/** SPEC-BTT-001: sets the browser tab title to `PacTrak - <Module>`. */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const label = this.resolveLabel(snapshot.root);
    this.title.setTitle(
      label
        ? `${PageTitle.brand}${PageTitle.separator}${label}`
        : PageTitle.brand
    );
  }

  /** Deepest mapped breadcrumb alias wins, so nested pages keep their module (D-BTT-003). */
  private resolveLabel(root: ActivatedRouteSnapshot): string | null {
    let label: string | null = null;
    let route: ActivatedRouteSnapshot | null = root;
    while (route) {
      const alias: unknown = route.data?.['breadcrumb']?.alias;
      const path = route.routeConfig?.path;
      if (typeof alias === 'string' && PageTitleByBreadcrumbAlias[alias]) {
        label = PageTitleByBreadcrumbAlias[alias];
      } else if (path && PageTitleByRoutePath[path]) {
        label = PageTitleByRoutePath[path];
      }
      route = route.firstChild;
    }
    return label;
  }
}
